import { Controller } from "@hotwired/stimulus"

// Lets owners add several camera photos one by one (each shot adds a fresh camera input)
// and shows which files are about to be uploaded.
export default class extends Controller {
  static targets = ["camera", "summary", "count", "list"]

  added(event) {
    const input = event.target
    if (input === this.cameraTarget && input.files.length > 0) {
      const fresh = input.cloneNode()
      fresh.value = ""
      input.removeAttribute("id")
      input.removeAttribute("data-file-picker-target")
      input.after(fresh)
    }
    this.render()
  }

  clear() {
    this.fileInputs.forEach((input) => {
      if (!input.id) input.remove()
      else input.value = ""
    })
    this.render()
  }

  render() {
    const files = this.fileInputs.flatMap((input) => Array.from(input.files))
    this.summaryTarget.hidden = files.length === 0
    this.countTarget.textContent = files.length === 1 ? "1 file ready" : `${files.length} files ready`
    this.listTarget.replaceChildren(...files.map((file, index) => {
      const li = document.createElement("li")
      li.textContent = file.name === "image.jpg" ? `Photo ${index + 1}` : file.name
      return li
    }))
  }

  get fileInputs() {
    return Array.from(this.element.querySelectorAll("input[type=file]"))
  }
}
